export const alertTypes = {
  ON_SET_ALERT: 'ON_SET_ALERT',
  SET_ALERT: 'SET_ALERT',
  REMOVE_ALERT: 'REMOVE_ALERT'
};

export default alertTypes;
